import LanguageCurrencySelector from '@/app/components/LanguageCurrencySelector'
import LanguageAndCurrencySelect from '@/app/components/LanguageAndCurrencyMobile'
import { Icons } from '@/app/components/ui/Icons'
import classNames from 'classnames'
import { pick } from 'lodash'
import { NextIntlClientProvider, useMessages } from 'next-intl'
import Image from 'next/image'
import Link from 'next/link'
import { FC } from 'react'
import CurrencySelector from './CurrencySelector'

interface LogoWithBlogBadgeProps {
	isDesktop?: boolean
	lang: string
}

const LogoWithBlogBadge: FC<LogoWithBlogBadgeProps> = ({
	isDesktop = false,
	lang,
}) => (
	<div className="flex items-center gap-2">
		<Link href={`/${lang}`} aria-label="Main Logo Link">
			<Image
				src="/images/logo.v2.svg"
				width={isDesktop ? 81 : 61}
				height={isDesktop ? 44 : 31}
				alt="Amenodo Logo"
			/>
		</Link>
		<div className={`${isDesktop ? 'h-[38px]' : 'h-[25px]'} w-px bg-main-950`} />
		<Link
			href={`/${lang}/blog`}
			className="text-main-950 font-normal text-sm leading-5 hover:underline"
		>
			BLOG
		</Link>
	</div>
)

export interface Props {
	lang: string
	isMain?: boolean
	isSticky?: boolean
	blogPage?: boolean
	children?: {
		middle?: React.ReactNode
		bottom?: React.ReactNode
	}
}

const Top: FC<Props> = (props) => {
	const { lang, isMain = false, children, isSticky, blogPage } = props
	const messages = pick(useMessages(), ['Keywords', 'Header'])

	return (
		<div
			className={classNames('container', {
				'py-3.5 md:py-6 sm:rounded-b-4xl max-w-full w-full 2xl:px-8 bg-white': !isMain,
				'max-lg:py-5 md:max-lg:px-8': isMain,
			})}
		>
			<div className={classNames('flex justify-between items-center h-[52px]',
				{
					'max-md:h-10': isMain
				})}>
				{blogPage ? (
					<div className="md:hidden">
						<LogoWithBlogBadge lang={lang} />
					</div>
				) : (
					<Link
						href={`/${lang}`}
						aria-label="Main Logo Link"
						className={'md:hidden'}
					>
						{isMain ? (
							<Image
								src="/images/logo.v2.svg"
								width={112}
								height={28}
								alt="Amenodo Logo"
								className="w-[112px] h-[28px]"
							/>
						) : (
							<Image
								src={'/images/logo-colored-sm.png'}
								width={30}
								height={30}
								alt="Amenodo Logo"
								className="w-[30px] h-[30px] max-w-[30px]"
								unoptimized
							/>
						)}
					</Link>
				)}
				<div className="hidden md:block h-full">
					{blogPage ? (
						<LogoWithBlogBadge isDesktop lang={lang} />
					) : (
						<Link
							href={`/${lang}`}
							aria-label="Main Logo Link"
							className="inline-block h-full"
						>
							{isMain ? (
								<Image
									src={'/images/logo.png'}
									width={112}
									height={28}
									alt="Amenodo Logo"
									unoptimized
								/>
							) : (
								<Image
									src={'/images/logo-colored.png'}
									width={112}
									height={28}
									alt="Amenodo Logo"
									unoptimized
								/>
							)}
						</Link>
					)}
				</div>
				{children?.middle}
				<NextIntlClientProvider locale={'en'} messages={messages}>
					<div className="md:hidden flex items-center">
						<LanguageAndCurrencySelect />
					</div>
					<div className="hidden md:flex justify-end">
						{/* <LanguageCurrencySelector
							isMainPage={isMain}
							isSticky={isSticky as boolean}
						/> */}
						<CurrencySelector
							isMainPage={isMain}
							isSticky={isSticky as boolean}
						/>
					</div>
				</NextIntlClientProvider>
			</div>
			{children?.bottom}
		</div>
	)
}

export default Top
